<template>
    <div>
        <div v-if="loadingNota" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else>

            <el-tabs type="border-card" v-model="tabAtivo" @tab-click="handleTabClick">

                <el-tab-pane name="notas" :label="nota.turma && nota.turma.metodo_avaliacao == 'quantitativo' ? 'NOTAS' : 'PARECER'">

                    <template v-if="nota.turma && nota.turma.metodo_avaliacao == 'quantitativo'">
                        <div class="u-text-right u-mb-5" style="margin-right: 6px;" v-if="$store.state.user.tipo == 6">
                            <el-button @click="openGerenciarCalcMedia()" type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                        </div>
                        <el-row :gutter="10" v-if="nota && nota.turma">
                            <el-col :xs="8" :sm="24" :md="24">
                                <div style="display: flex;">

                                    <div v-for="(periodo, i) in nota.turma.periodos_diario" :key="i" style="flex: 1; margin: 0 5px;">
                                        <table class="table table-striped table-nota">
                                            <thead>
                                                <tr class="linha-nota">
                                                    <th class="u-text-center" :colspan="defineQtdAtividades[i+1] + 3">{{ periodo }}</th>
                                                </tr>
                                                <tr>
                                                    <th class="u-text-left" style="width: 140px;">Disciplinas</th>
                                                    <th v-for="(atividades, k) in defineQtdAtividades[i+1]" :key="`d${i+k}`" class="vertical-text">
                                                        Atividade {{ String(k+1).padStart(2, '0') }}
                                                    </th>
                                                    <th class="vertical-text">Média</th>
                                                    <th class="vertical-text">Recuperação</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(disc, j) in nota.atividades" :key="`n${i+j}`" class="linha-nota">
                                                    <td @dblclick="selecionaNota(j, i+1)"  class="u-text-left u-pointer"><span class="u-pl-10">{{ nota['disciplinas'][j] }}</span></td>
                                                    <template v-for="(item, y) in disc[i+1]" >
                                                        <td @dblclick="removerNota(j, i+1, y)" v-if="y != 'm' && y != 'r'" :key="`i${i+j+y}`" class="u-text-center u-pointer">
                                                            
                                                            
                                                            <span v-if="$store.state.user.id == nota.atividades[j][i+1][y]['u']" style="font-weight: bold; color: #00aaff;">
                                                                {{ nota.atividades[j][i+1][y]['v'] }}
                                                            </span>
                                                            <span v-else>
                                                                {{ nota.atividades[j][i+1][y]['v'] }}
                                                            </span>
                                                                                                                        
                                                        </td>
                                                    </template>
                                                    <td v-for="(item, m) in defineQtdAtividades[i+1] - (Object.keys(disc[i+1]).length - 2)" :key="`v${i+j+m}`" class="u-text-center"></td>
                                                    <td class="u-text-center">{{ nota.atividades[j][i+1]['m']['v'] }}</td>
                                                    <td class="u-text-center">
                                                        {{ nota.atividades[j][i+1]['r']['v'] }}
                                                    </td>
                                                </tr>
                                                    
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </el-col>
                        </el-row>
                        
                        <el-row class="u-mt-20" :gutter="10">
                            <el-col :xs="8" :sm="24" :md="24">
                                <table class="table table-striped table-nota">
                                    <thead>
                                        <tr class="linha-nota">
                                            <th class="u-text-center" colspan="11">MÉDIA PARCIAL</th>
                                        </tr>
                                        <tr>
                                            <th class="u-text-center">Disciplina</th>
                                            <th v-for="(item, j) in nota.atividades" :key="j" class="u-text-center">{{ nota['disciplinas'][j] }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="linha-nota">
                                            <td class="u-text-center">NOTA</td>
                                            <td class="u-text-center" v-for="(item, j) in nota.atividades" :key="j">{{ item['m_parcial'] && (item['m_parcial']['v'] || item['m_parcial']['v'] === 0) ? item['m_parcial']['v'] : 'SN' }}</td>
                                        </tr>            
                                    </tbody>
                                </table>
                            </el-col>
                        </el-row>

                        <el-row class="u-mt-20" :gutter="10">
                            <el-col :xs="8" :sm="24" :md="24">
                                <table class="table table-striped table-nota">
                                    <thead>
                                        <tr class="linha-nota">
                                            <th class="u-text-center" colspan="11">RECUPERAÇÃO FINAL</th>
                                        </tr>
                                        <tr>
                                            <th class="u-text-center">Disciplina</th>
                                            <th @dblclick="selecionaNota(j, 'r')" v-for="(item, j) in nota.atividades" :key="j" class="u-text-center u-pointer">{{ nota['disciplinas'][j] }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="linha-nota">
                                            <td class="u-text-center">NOTA</td>
                                            <td @dblclick="removerNota(j, 'r', null)" v-for="(item, j) in nota.atividades" :key="j" class="u-text-center u-pointer">

                                                <span v-if="$store.state.user.id == item['r']['u']" style="font-weight: bold; color: #00aaff;">
                                                    {{ (item['r'] && item['r']['v'] ? item['r']['v'] : '') }}
                                                </span>
                                                <span v-else>
                                                    {{ (item['r'] && item['r']['v'] ? item['r']['v'] : '') }}
                                                </span>
                                                
                                                
                                            </td>
                                        </tr>            
                                    </tbody>
                                </table>                            
                            </el-col>
                        </el-row>

                        <el-row class="u-mt-20" :gutter="10">
                            <el-col :xs="8" :sm="24" :md="24">
                                <table class="table table-striped table-nota">
                                    <thead>
                                        <tr class="linha-nota">
                                            <th class="u-text-center" colspan="11">MÉDIA FINAL</th>
                                        </tr>
                                        <tr>
                                            <th class="u-text-center">Disciplina</th>
                                            <th v-for="(item, j) in nota.atividades" :key="j" class="u-text-center">{{ nota['disciplinas'][j] }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="linha-nota">
                                            <td class="u-text-center">NOTA</td>
                                            <td class="u-text-center" v-for="(item, j) in nota.atividades" :key="j">{{ item['m_final'] && item['m_final']['v'] ? item['m_final']['v'] : '' }}</td>
                                        </tr>            
                                    </tbody>
                                </table>
                            </el-col>
                        </el-row>

                    </template>

                    <template v-else-if="nota.turma">

                        <fieldset v-for="(periodo, i) in nota.turma.periodos_diario" :key="i" class="fieldset-nota">
                            <legend>PARECER {{ periodo }}</legend>
                            {{ nota.parecer[i + 1] }}
                        </fieldset>

                    </template>

                </el-tab-pane>

                <el-tab-pane name="parecer" :label="nota.turma && nota.turma.metodo_avaliacao == 'quantitativo' ? 'PARECER' : 'PARECER FINAL'">

                    <template v-if="nota && nota.notas_parecer && nota.notas_parecer.parecer">
                        <el-row :gutter="10" v-for="(item, i) in nota.notas_parecer.parecer" :key="i">
                            <el-col :xs="24" :sm="24" :md="24">

                                <div style="border: 1px solid #a9a9a9; border-radius: 12px; padding: 30px;">
                                    <div style="font-size: 17px;">Parecer / Observação - {{ i }}º Trimestre</div>
                                    <div v-if="item">                                    
                                        <hr class="u-mt-30">{{ item }}</hr>
                                    </div>
                                    <div v-else>
                                        <hr class="u-mt-30" />
                                        <hr class="u-mt-30" />
                                        <hr class="u-mt-30" />
                                        <hr class="u-mt-30" />
                                    </div>
                                </div>

                            </el-col>
                        </el-row>
                    </template>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">

                            <div style="border: 1px solid #a9a9a9; border-radius: 12px; padding: 30px;">
                                <span style="font-size: 17px;">Resultados finais</span>
                                <i>
                                    Conselho de classe - O parecer conclusivo é de caráter coletivo e deverá ser elaborado pelo conselho de classe com a
                                    presença de todos os professores, conforme estabelecido no regimento escolar.

                                </i>
                                <div v-if="nota.conselho_parcial">                                    
                                    <hr class="u-mt-30"><span v-if="nota.parecer_final">{{ nota.parecer_final }}<br/></br></span>{{ nota.conselho_parcial['observacao'] }}</hr>
                                </div>
                                <div v-else-if="nota.conselho_final">                                    
                                    <hr class="u-mt-30"><span v-if="nota.parecer_final">{{ nota.parecer_final }}<br/></br></span>{{ nota.parecer_final }} {{ nota.conselho_final['observacao'] }}</hr>
                                </div>
                                <div v-else>
                                    <hr class="u-mt-30" />
                                    <hr class="u-mt-30" />
                                    <hr class="u-mt-30" />
                                    <hr class="u-mt-30" />
                                </div>
                            </div>

                        </el-col>
                    </el-row>

                </el-tab-pane>

                <el-tab-pane name="observacoes" label="OBSERVAÇÕES">
                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Data</th>
                                    <th>Observação</th>
                                    <th>Usuário</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loadingObservacoes">
                                <tr v-for="item in observacoes" :key="item.id">
                                    <td>{{ $moment(item.created_at).format('DD/MM/YYYY HH:mm') }}</td>
                                    <td>{{ formatarTexto(item.observacao) }}</td>
                                    <td>{{ item.user ? item.user.name : '-' }}</td>
                                    
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="loadingObservacoes" class="u-text-center u-mt-25">
                            <img src="/public/img/loading-bar.gif" />
                        </div>
                        <el-row :gutter="10" v-if="!loadingObservacoes">
                            <el-col :xs="24" :sm="12" :md="12">
                                <div class="u-text-left u-mt-10">
                                    Mostrando {{ paginateObservacoes.from }} até {{ paginateObservacoes.to }} de {{ paginateObservacoes.qtdItens }} registros encontrados.
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12" v-if="paginateObservacoes.qtdItens > 30">
                                <div class="u-text-right">
                                        <el-pagination :current-page='paginateObservacoes.page' class="u-mt-10" :total="paginateObservacoes.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                                    </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>

            </el-tabs>
            <div class="u-text-right u-mt-10">
                <el-button type="primary" @click="close">FECHAR</el-button>
            </div>

        </div>        

        <el-dialog :close-on-click-modal="false" title="GERENCIAR NOTA" width="20%" top="40px" :visible.sync="dialogChangeNota" v-on:close="closeDialogChangeNota" append-to-body>
            <div v-if="dialogChangeNota" style="margin-top: 20px;">
                <el-form @submit.native.prevent="onSubmitChangeNota" :model="changeNota" ref="changeNota" label-position="top">
                    
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="nota" prop="nota" :rules="[$requiredBlur]" key="nota">
                                <el-input v-model="changeNota.nota" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <i>Atenção: Para fins de rastreabilidade, será criado um log associando o seu usuário ao cadastro desta nota.</i>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" id="btn-modelo" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>                        
                    
                </el-form>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" title="GERENCIAR CÁLCULO DE MÉDIA" top="40px" width="30%" :visible.sync="dialogGerenciarCalcMedia">
            <div v-if="dialogGerenciarCalcMedia" style="margin-top: 20px;">
                
                <el-form @submit.native.prevent="onSubmitGerenciarCalcMedia()" :model="calcNota" ref="calcNota" label-position="top">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Situação" prop="qtd_dvisao" key="qtd_dvisao">
                            <el-select style="z-index: 1000;" v-model="calcNota.qtd_dvisao">
                                <el-option key="" label="Padrão do sistema" value=""></el-option>
                                <el-option :key="1" label="÷ 1" :value="1"></el-option>
                                <el-option :key="2" label="÷ 2" :value="2"></el-option>                                
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-row :gutter="10"> 
                        <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                            <el-button type="primary" native-type="submit" class="u-mt-5">SALVAR</el-button>
                        </el-col>
                    </el-row>
                </el-form>
                
            </div>
        </el-dialog>
    </div>
</template>
<script>

import Decimal from "../../../../shared/moneys/component.vue"

export default {
    props: ['id', 'turma_id', 'aluno_id', 'mostra_gerenciar_nota'],
    data: () => ({
        dialogGerenciarCalcMedia: false,
        alunoSelected: {},
        defineQtdAtividades: {},
        loadingObservacoes: false,
        tabAtivo: 'notas',
        nota: {},
        loadingNota: true,
        dialogChangeNota: false,
        observacoes: [],
        paginateObservacoes: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        changeNota: {
            aluno_id: '',
            turma_id: '',
            disciplina: '',
            periodo: '',
            nota: ''
        },
        calcNota: {
            qtd_dvisao: ''
        }
    }),
    mounted () {
        
        this.getNota();        
    },
    methods: {

        openGerenciarCalcMedia(){

            this.loading = true;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/getCalcNotaQtdDvisao/${this.aluno_id}/${this.turma_id}`, this.$store.getters.getHeaderAuth).then(response => {

                if(response.data.calc_nota_qtd_dvisao > 0) {
                    
                    this.calcNota.qtd_dvisao = response.data.calc_nota_qtd_dvisao;
                }

                this.dialogGerenciarCalcMedia = true;
                
                this.loading = false;
                
            }).catch((error) => { this.$store.commit('throwException', error); window.eventBus.$emit('loading', false); });
            
        },
        onSubmitGerenciarCalcMedia() {

            this.$refs.calcNota.validate((valid) =>{ if(valid){

                this.$msgbox.confirm(`Tem certeza que deseja alterar a fórmula de cálculo da média deste aluno?`, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                    window.eventBus.$emit('loading', true);

                    let payload = {
                        aluno_id: this.aluno_id,
                        turma_id: this.turma_id,
                        qtd_dvisao: this.calcNota.qtd_dvisao
                    };

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/storeCalcNotaQtdDvisao`, payload, this.$store.getters.getHeaderAuth).then(response => {
                                                
                        if(typeof response.data.erro !== 'undefined'){

                            this.$alert(response.data.erro, 'Atenção', {
                                confirmButtonText: 'OK',
                                type: 'warning'
                            }).catch(()=>{});

                        }else{
                            
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.dialogGerenciarCalcMedia = false;
                        }

                        window.eventBus.$emit('loading', false);

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }).catch(()=>{});

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },







        handleTabClick(tab) {

            if (tab._props.name === 'observacoes') {
                this.getObservacoes()
            }
        },
        getObservacoes() {

            let payload = {};

            if(this.id) {

                payload['id'] = this.id;

            } else {

                payload['turma_id'] = this.turma_id;
                payload['aluno_id'] = this.aluno_id;
            }

            this.loadingObservacoes = true;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/getDiarioObservacoes`, payload, this.$store.getters.getHeaderAuth).then(response => {

                this.observacoes = response.data.data; 
                this.paginateObservacoes.qtdItens = response.data.total;
                this.paginateObservacoes.from = response.data.from;
                this.paginateObservacoes.to = response.data.to;

                this.loadingObservacoes = false;

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
        removerNota(disciplina, periodo, atividade){

            if(!this.mostra_gerenciar_nota) {
                return;
            }

            if(this.$store.state.user.tipo == 7){
                return;
            }

            this.$msgbox.confirm('Tem certeza que deseja excluir este nota? Não será possível desfazer a exclusão.', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                let payload = {
                    aluno_id: this.aluno_id,
                    turma_id: this.turma_id,
                    disciplina,
                    periodo,
                    atividade
                };

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota/removerNota`, payload, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.error !== 'undefined'){

                        this.$alert(response.data.error, 'Atenção', { confirmButtonText: 'OK' });

                    }else{

                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.getNota();
                    }

                    window.eventBus.$emit('loading', false);

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },  
        selecionaNota(disciplina, periodo) {

            if(!this.mostra_gerenciar_nota) {
                return;
            }

            if(this.$store.state.user.tipo == 7){
                return;
            }

            this.changeNota.aluno_id = this.aluno_id;
            this.changeNota.disciplina = disciplina;
            this.changeNota.periodo = periodo;
            this.changeNota.turma_id = this.turma_id;
            this.dialogChangeNota = true;
        },
        onSubmitChangeNota() {

            this.$refs.changeNota.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                this.changeNota.nota = this.changeNota.nota.replace(',', '.');

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota/customNota`, this.changeNota, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.error !== 'undefined'){

                        this.$alert(response.data.error, 'Atenção', { confirmButtonText: 'OK' });

                    }else{

                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.getNota();
                        this.dialogChangeNota = false;
                    }

                    window.eventBus.$emit('loading', false);

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        closeDialogChangeNota() {
            
            this.changeNota = {
                aluno_id: '',
                turma_id: '',
                disciplina: '',
                periodo: '',
                nota: '',
                observacao: ''
            };
        },
        getNota(){

            this.loadingNota = false;

            let payload = {};

            if(this.id) {

                payload['id'] = this.id;

            } else {

                payload['turma_id'] = this.turma_id;
                payload['aluno_id'] = this.aluno_id;
            }
            
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota/getNotaByFiltros`, payload, this.$store.getters.getHeaderAuth).then(response => {

                if(typeof response.data.error !== 'undefined'){

                    window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});
                    this.$emit('close');

                }else{

                    this.nota = response.data; 
                                                          
                    if(this.nota.turma.metodo_avaliacao == 'quantitativo') {
                        
                        for(let i in this.nota.atividades) {
                            let atividade = this.nota.atividades[i];
                            Object.entries(atividade).forEach(([k2, val]) => {
                                if (this.defineQtdAtividades[k2] && this.defineQtdAtividades[k2] > (Object.keys(val).length - 2)) {
                                    return;
                                }
                                this.defineQtdAtividades[k2] = Object.keys(val).length < 8 ? 6: Object.keys(val).length - 2;
                            });
                        }
                    }

                    this.loadingNota = false;

                } 

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },     
        close(){
            this.$emit('close');
        },
        getPagePagination(page){
          this.paginateObservacoes.page = page;
          this.getObservacoes();
        },
        formatarTexto(texto) {

            if(texto == '' || texto == null) {
                return texto;
            }

            texto = texto.toLowerCase();

            const partes = texto.split(" ");

            partes[0] = partes[0].charAt(0).toUpperCase() + partes[0].slice(1);

            return partes.join(" ");
        }
    },
    components:{ Decimal }
}
</script>
<style>
    .table-nota td, .table-nota th {
        border: 1px solid #ccc !important;
    }
    .vertical-text {
        writing-mode: vertical-rl;
        transform: rotate(180deg);
        padding: 10px;
        height: 90px;
        text-align: center;
        width: 35px !important;
    }
    .input-nota .el-input__inner {
        border: none !important;
        background-color: #efefef;
        text-align: center;
    }

    .table-nota.table th, .table-nota.table td {
        padding: 0px !important;
    }

    .linha-nota th, .linha-nota td {
        height: 25px !important;
    }

    .fieldset-nota{
        min-height: 150px;
        text-transform: uppercase;
        padding: 10px;
        border-radius: 10px;
        margin: 20px 0;
    }

</style>